import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCoreAccessRedirectRoute: InvariantJiraRoute = {
	name: 'project-settings-core-access-redirect',
	path: '/jira/core/projects/:projectKey/settings/people',
	exact: true,
};
